module.exports = __webpack_public_path__ + "static/media/details-29-image-6.027a2fed.jpg";